import { render, staticRenderFns } from "./MarketingPlanDetail.vue?vue&type=template&id=4ca78922&scoped=true"
import script from "./MarketingPlanDetail.vue?vue&type=script&lang=js"
export * from "./MarketingPlanDetail.vue?vue&type=script&lang=js"
import style0 from "./MarketingPlanDetail.vue?vue&type=style&index=0&id=4ca78922&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca78922",
  null
  
)

export default component.exports